import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse } from '@/api/patterns/crud';
import type { PendingRegistrationItem } from '../types';

export const pendingRegistrationsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPendingRegistrations: builder.query<PendingRegistrationItem[], void>({
      query: () => '/platform/pending-registrations',
      transformResponse: unwrapListResponse<PendingRegistrationItem>,
      providesTags: [{ type: 'PlatformOrgNumberReg', id: 'PENDING-LIST' }],
    }),
  }),
});

export const { useGetPendingRegistrationsQuery } = pendingRegistrationsApi;
